module.exports = __webpack_public_path__ + "img/hi.045acef8.png";